<template>
	<div class="popup rounded-top-45 pb-4 bg-white flex flex-column">

		<!-- 顶部信息 -->
		<div class="popup-header mx-4 py-3 flex align-center justify-between mb-4 border-bottom">
			<!-- -->
			<div class="flex" v-if="type === 1">
				<div class="flex align-center mr-7" style="margin-right:30px">
					<div class="icon-circle rounded-circle complete"></div>
					<span class="text-primary font-sm pl-1">已做</span>
				</div>
				<div class="flex align-center">
					<div class="icon-circle rounded-circle unfinished"></div>
					<span class="text-body font-sm pl-1">未做</span>
				</div>
			</div>

			<div class="flex" v-else>
				<div class="flex align-center mr-4">
					<div class="icon-circle rounded-circle success"></div>
					<span class="text-primary font-sm pl-1">正确</span>
				</div>
				<div class="flex align-center mr-4">
					<div class="icon-circle rounded-circle error"></div>
					<span class="text-danger pl-1 font-sm">错误</span>
				</div>
				<div class="flex align-center mr-4">
					<div class="icon-circle rounded-circle bg-light"></div>
					<span class="text-body pl-1 font-sm">未判</span>
				</div>
				<div class="flex align-center">
					<div class="icon-circle rounded-circle half"></div>
					<span class="text-body pl-1 font-sm">半对半错</span>
				</div>
			</div>

			<div class="p-1" @click="handleClose">
				<image :src="`${imageUrl.cdnStaticUrl}/learn/answer/icon-close.png`" mode="widthFix" class="icon"></image>
			</div>
		</div>

		<!-- 答题号 -->
		<div class="popup-body">
			<div class="aq-con flex">
					<!-- 答题情况 -->
					<div v-if="type === 1" class="flex flex-wrap">
						<div v-for="(item, index) in listDo" :key="index" class="item-wrap">
							<div v-if="item.cur === false" class="aq-item mx-4 mb-5 bg-light rounded-circle flex align-center justify-center" @click="toItemHandle(index)">
								<span class="font-sm text-dark">{{ index + 1 }}</span>
							</div>
							<div v-else class="aq-item mx-4 mb-5 rounded-circle flex align-center justify-center complete" @click="toItemHandle(index)">
								<span class="font-sm text-white">{{ index + 1 }}</span>
							</div>
						</div>
					</div>
					<!-- 查看解析 -->
					<div v-else class="flex flex-wrap" >
						<div v-for="(item, index) in lists" :key="index">
							<div v-if="item.answerResult === 'SUCCESS'" class="aq-item mx-4 mb-5 success rounded-circle flex align-center justify-center" @click="toCartItem(index)">
								<span class="font-sm text-white">{{ index + 1 }}</span>
							</div>
							<div v-else-if="item.answerResult === 'HALF'" class="aq-item mx-4 mb-5 half rounded-circle flex align-center justify-center" @click="toCartItem(index)">
								<span class="font-sm text-white">{{ index + 1 }}</span>
							</div>
							<div v-else-if="item.answerResult === 'ERROR'" class="aq-item mx-4 mb-5 error rounded-circle flex align-center justify-center" @click="toCartItem(index)">
								<span class="font-sm text-white">{{ index + 1 }}</span>
							</div>
							<div v-else class="aq-item mx-4 mb-5 bg-light rounded-circle flex align-center justify-center" @click="toCartItem(index)">
								<span class="font-sm text-dark">{{ index + 1 }}</span>
							</div>
						</div>
					</div>
			</div>
		</div>

		<!-- 操作 -->
		<div class="popup-footer pt-3 px-4">
			<!-- 做题模式 -->
			<div v-if="type === 1" class="flex align-center">
				<!-- <div class="flex align-center justify-center py-3">
					<span class="tips">点击题号可进行修改答案</span>
				</div> -->
				<div class="small-submit align-center justify-center main-bg-color rounded-circle" @click="submit(1)">
					<span class="font-sm text-white">提交</span>
				</div>
        <div class="back-btn flex align-center justify-center main-bg-color rounded-circle" @click="submit(3)">
          <span class="font-sm text-white">返回做题</span>
        </div>
			</div>
			<!-- 查看解析 -->
			<div v-else class="btn flex align-center justify-center main-bg-color rounded-circle" @click="submit(2)">
				<span class="font-sm text-white">再做一遍</span>
			</div>
		</div>

	</div>
</template>

<script>
	export default {
		name: 'QuestionAnswerCart',
		props: {
			mapKey: String,
			type: Number,
			lists: Array, // 解析数据
			totalCount: Number
		},
		data() {
			return {
                imageUrl:{
                    cdnStaticUrl:'https://static.hejihua.com/middle/app/study/images'
                },
				imgBaseUrl: 'https://stb.ttxinli.com/stb',
				listDo: [] // 答题数据
			};
		},
		created() {
			this.init()
		},
		methods: {
			// 关闭
			handleClose() {
				this.$emit('toCartItem');
			},
			// 跳转 定位到 每一题
			toItemHandle(params) {
				this.$emit('toCartItem', params);
			},
			// 提交
			submit(params) {
				this.$emit('submitHandle', params)
			},
			// 初始化 获取答题
			init() {
				this.listDo = []
				for (let index = 0; index < this.totalCount; index++) {
					// 循环体
					let item = { cur: false }
					// 答题卡回显
					if (window.localStorage.getItem(this.mapKey)) {
						let getSubjectsList = JSON.parse(window.localStorage.getItem(this.mapKey));
						let subjectsList = Object.values(getSubjectsList)
						for (let i = 0; i < subjectsList.length; i++) {
							if (index === Number(subjectsList[i].serialNumber) && subjectsList[i].userAnswers.length > 0) {
								item.cur = true
							}
						}
					}
					this.listDo.push(item)
				}
			}
		}
	}
</script>

<style scoped>  
    .flex {
        display: flex;
    }
    .flex-wrap {
        flex-wrap:wrap;
    }
    .popup {
        flex-flow: column nowrap;
        justify-content: space-between;
        padding: 30px;
    }
	.icon {
		height: 40px;
		width: 40px;
	}

	.icon-circle {
		height: 14px;
    width: 14px;
    border-radius: 50%;
    margin-right: 3px;
	}
  .align-center {
    align-items: center;
  }
    .popup-body {
        height: 627px;
    }
	.aq-con {
        padding: 30px 0;
	}
    .item-wrap {
        width: 40px;
        height: 40px;
        margin-left: 55px;
        margin-bottom: 30px;
    }
    .item-wrap:nth-child(5n+1){
        margin-left: 0;
    }
	.aq-item {
		width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #eef0f4;
    align-items: center;
    justify-content: center;
    cursor: pointer;
	}
  
	.aq-item.success {
		color: #fff;
		background-color: #00c7b0;
	}
    .complete {
        color:#fff;
        background-color: #F17070;
    }
    .unfinished {
        color: #2E323C;
        background-color: #F1F3F8;

    }
	.error {
		background-color: #F94E4E;
	}

	.success {
		background-color: #00c7b0;
	}

	.half {
		background-color: #FFB36A;
	}

	.btn {
		height: 80px;
    }
    .submit-btn {
        width: 420px;
        height: 42px;
        border-radius: 21px;
        line-height: 42px;
        font-size: 14px;
        text-align: center;
        font-weight: 500;
        background: #E13F37;
        color: #FFFFFF;
        margin:0 auto;
        cursor: pointer;
    }
    .tips {
        display: block;
        font-size: 14px;
        color: #8d92a3;
        margin: 0px auto 20px;
    }
    .small-submit  {
      width: 150px;
      height: 42px;
      background: #FFFFFF;
      border-radius: 21px;
      border: 1px solid #8D92A3;
      font-size: 14px;
      font-weight: 500;
      color: #2E323C;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
    .back-btn {
      width: 250px;
      height: 42px;
      background: #E13F37;
      border-radius: 21px;
      font-size: 14px;
      font-weight: 500;
      color: #FFFFFF;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 20px;
      cursor: pointer;
    }
</style>
